import { render } from "./LogoSVG.vue?vue&type=template&id=7d1a04d0"
import script from "./LogoSVG.vue?vue&type=script&lang=js"
export * from "./LogoSVG.vue?vue&type=script&lang=js"

import "./LogoSVG.vue?vue&type=style&index=0&id=7d1a04d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__